import { Component, OnInit, Inject, DoCheck } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material";
import { Photos } from "src/app/models/photo.model";
import { CommonService } from "src/app/services/common.service";
import { DialogService } from "src/app/services/dialog.service";
import { NotificationService } from "src/app/services/notification.service";

@Component({
  selector: "app-view-photo-modal",
  templateUrl: "./view-photo-modal.component.html",
  styleUrls: ["./view-photo-modal.component.css"],
})
export class ViewPhotoModalComponent implements OnInit {
  photo!: Photos;
  step : number = 0;
  photosArray?: Array<Photos>;
  recordId?: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected dialogRef: MatDialogRef<ViewPhotoModalComponent>,
    protected dialogService: DialogService,
    protected dialog: MatDialog,
    protected commonService: CommonService,
    protected notificationService: NotificationService,
  ) {
    this.step = 0;
  }

  ngOnInit(): void {
    this.photo = { ...this.data?.photo };
    this.photosArray = this.data?.photosArray;
    this.recordId = this.data?.recordId;

    console.log(this.photo);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  

  //removes the images from the Array
  public removeImage() {
    this.dialogService
      .openConfirmDialog(
        "Delete Image",
        "Are you sure you want to Delete the Image ?"
      )
      .afterClosed()
      .subscribe((confirm: boolean) => {
        if (confirm){
          this.dialogRef.close(`removePhoto`);
        } 
      });
  }

  //removes the images as default
  public removeDefaultImage() {
    this.dialogService
      .openConfirmDialog(
        "Remove Default",
        "Are you sure you want to remove Photo as default  ?"
      )
      .afterClosed()
      .subscribe((confirm: boolean) => {
        if (confirm){
          this.dialogRef.close(`removeDefault`);
        } 
      });
  }

  //sets the default image
  public setDefaultImage(imageIndex: number) {
   this.dialogRef.close(`setPrimayPhoto`)
  }

  setStep(index: number): void {
    this.step = index;
  }

  onImageError() {
    if (!this.recordId || !this.photosArray?.length) {
      return;
    }
    this.commonService.getAllFiles(this.photosArray, [], this.recordId)
      .then(() => {
        this.commonService?.allFiles?.forEach(element => {
          if (element?.Photos?.length > 0) {
            if (element.RecordID === this.recordId) {
              this.photo.SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
              this.photo.SignedURL = element.Photos[0].SignedURL;
            }
          }
        });
      })
      .catch((err) => {
        this.notificationService.failure(err);
      }); 
  }
  
}

